import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { EventManager } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  private readonly renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private readonly doc: Document,
    private readonly eventManager: EventManager,
    rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  removeScript(id: string): void {
    const scriptElement = this.doc.getElementById(id);

    if (scriptElement) {
      scriptElement.remove();
    }
  }

  updateInlineScript(id: string, code: string): HTMLScriptElement {
    this.removeScript(id);

    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(script, 'id', id);
    this.renderer.appendChild(script, this.renderer.createText(code));

    this.renderer.appendChild(this.doc.body, script);

    return script;
  }

  updateExternalScript(id: string, url: string): Promise<HTMLScriptElement> {
    this.removeScript(id);

    return new Promise((resolve, reject) => {
      const script = this.renderer.createElement('script');
      this.renderer.setAttribute(script, 'id', id);
      this.renderer.setAttribute(script, 'src', url);
      this.eventManager.addEventListener(script, 'load', () => resolve(script));
      this.eventManager.addEventListener(script, 'error', reject);

      this.renderer.appendChild(this.doc.body, script);
    });
  }
}
